import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from '@/store'
import router from '@/router'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// eslint-disable-next-line
declare var require: Function

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
